// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import flagAF from '../../../assets/img/flagsCountry/flag-AF.png';
// @ts-ignore
import flagAX from '../../../assets/img/flagsCountry/flag-AX.png';
// @ts-ignore
import flagAL from '../../../assets/img/flagsCountry/flag-AL.png';
// @ts-ignore
import flagDZ from '../../../assets/img/flagsCountry/flag-DZ.png';
// @ts-ignore
import flagAS from '../../../assets/img/flagsCountry/flag-AS.png';
// @ts-ignore
import flagAD from '../../../assets/img/flagsCountry/flag-AD.png';
// @ts-ignore
import flagAO from '../../../assets/img/flagsCountry/flag-AO.png';
// @ts-ignore
import flagAI from '../../../assets/img/flagsCountry/flag-AI.png';
// @ts-ignore
import flagAG from '../../../assets/img/flagsCountry/flag-AG.png';
// @ts-ignore
import flagAR from '../../../assets/img/flagsCountry/flag-AR.png';
// @ts-ignore
import flagAM from '../../../assets/img/flagsCountry/flag-AM.png';
// @ts-ignore
import flagAW from '../../../assets/img/flagsCountry/flag-AW.png';
// @ts-ignore
import flagAU from '../../../assets/img/flagsCountry/flag-AU.png';
// @ts-ignore
import flagAT from '../../../assets/img/flagsCountry/flag-AT.png';
// @ts-ignore
import flagAZ from '../../../assets/img/flagsCountry/flag-AZ.png';
// @ts-ignore
import flagBS from '../../../assets/img/flagsCountry/flag-BS.png';
// @ts-ignore
import flagBH from '../../../assets/img/flagsCountry/flag-BH.png';
// @ts-ignore
import flagBD from '../../../assets/img/flagsCountry/flag-BD.png';
// @ts-ignore
import flagBB from '../../../assets/img/flagsCountry/flag-BB.png';
// @ts-ignore
import flagBY from '../../../assets/img/flagsCountry/flag-BY.png';
// @ts-ignore
import flagBE from '../../../assets/img/flagsCountry/flag-BE.png';
// @ts-ignore
import flagBJ from '../../../assets/img/flagsCountry/flag-BJ.png';
// @ts-ignore
import flagBZ from '../../../assets/img/flagsCountry/flag-BZ.png';
// @ts-ignore
import flagBM from '../../../assets/img/flagsCountry/flag-BM.png';
// @ts-ignore
import flagBT from '../../../assets/img/flagsCountry/flag-BT.png';
// @ts-ignore
import flagBO from '../../../assets/img/flagsCountry/flag-BO.png';
// @ts-ignore
import flagBA from '../../../assets/img/flagsCountry/flag-BA.png';
// @ts-ignore
import flagBW from '../../../assets/img/flagsCountry/flag-BW.png';
// @ts-ignore
import flagBV from '../../../assets/img/flagsCountry/flag-BV.png';
// @ts-ignore
import flagBR from '../../../assets/img/flagsCountry/flag-BR.png';
// @ts-ignore
import flagIO from '../../../assets/img/flagsCountry/flag-IO.png';
// @ts-ignore
import flagBN from '../../../assets/img/flagsCountry/flag-BN.png';
// @ts-ignore
import flagBG from '../../../assets/img/flagsCountry/flag-BG.png';
// @ts-ignore
import flagBF from '../../../assets/img/flagsCountry/flag-BF.png';
// @ts-ignore
import flagBI from '../../../assets/img/flagsCountry/flag-BI.png';
// @ts-ignore
import flagKH from '../../../assets/img/flagsCountry/flag-KH.png';
// @ts-ignore
import flagCM from '../../../assets/img/flagsCountry/flag-CM.png';
// @ts-ignore
import flagCA from '../../../assets/img/flagsCountry/flag-CA.png';
// @ts-ignore
import flagCV from '../../../assets/img/flagsCountry/flag-CV.png';
// @ts-ignore
import flagKY from '../../../assets/img/flagsCountry/flag-KY.png';
// @ts-ignore
import flagCF from '../../../assets/img/flagsCountry/flag-CF.png';
// @ts-ignore
import flagTD from '../../../assets/img/flagsCountry/flag-TD.png';
// @ts-ignore
import flagCL from '../../../assets/img/flagsCountry/flag-CL.png';
// @ts-ignore
import flagCN from '../../../assets/img/flagsCountry/flag-CN.png';
// @ts-ignore
import flagCX from '../../../assets/img/flagsCountry/flag-CX.png';
// @ts-ignore
import flagCC from '../../../assets/img/flagsCountry/flag-CC.png';
// @ts-ignore
import flagCO from '../../../assets/img/flagsCountry/flag-CO.png';
// @ts-ignore
import flagKM from '../../../assets/img/flagsCountry/flag-KM.png';
// @ts-ignore
import flagCG from '../../../assets/img/flagsCountry/flag-CG.png';
// @ts-ignore
import flagCD from '../../../assets/img/flagsCountry/flag-CD.png';
// @ts-ignore
import flagCK from '../../../assets/img/flagsCountry/flag-CK.png';
// @ts-ignore
import flagCR from '../../../assets/img/flagsCountry/flag-CR.png';
// @ts-ignore
import flagCI from '../../../assets/img/flagsCountry/flag-CI.png';
// @ts-ignore
import flagHR from '../../../assets/img/flagsCountry/flag-HR.png';
// @ts-ignore
import flagCU from '../../../assets/img/flagsCountry/flag-CU.png';
// @ts-ignore
import flagCY from '../../../assets/img/flagsCountry/flag-CY.png';
// @ts-ignore
import flagCZ from '../../../assets/img/flagsCountry/flag-CZ.png';
// @ts-ignore
import flagDK from '../../../assets/img/flagsCountry/flag-DK.png';
// @ts-ignore
import flagDJ from '../../../assets/img/flagsCountry/flag-DJ.png';
// @ts-ignore
import flagDM from '../../../assets/img/flagsCountry/flag-DM.png';
// @ts-ignore
import flagEG from '../../../assets/img/flagsCountry/flag-EG.png';
// @ts-ignore
import flagEC from '../../../assets/img/flagsCountry/flag-EC.png';
const CountriesA = [
    {
        ru: 'Афганистан',
        lt: 'Afganistanas',
        tr: 'Afganistan',
        en: 'Afghanistan',
        flagIcon: '🇦🇫',
        code: 'AF',
        flag: flagAF,
        dialCode: '93',
        mask: '999 999 9999',
    },
    {
        ru: 'Аландские острова',
        lt: 'Alandų salos',
        tr: 'Aland adaları',
        en: 'Åland Islands',
        flagIcon: '🇦🇽',
        code: 'AX',
        flag: flagAX,
        dialCode: '358',
        mask: '999 9999999',
    },
    {
        ru: 'Албания',
        lt: 'Albanija',
        tr: 'Arnavutluk',
        en: 'Albania',
        flagIcon: '🇦🇱',
        code: 'AL',
        flag: flagAL,
        dialCode: '355',
        mask: '999 999 9999',
    },
    {
        ru: 'Алжир',
        lt: 'Alžyras',
        tr: 'Cezayir',
        en: 'Algeria',
        flagIcon: '🇩🇿',
        code: 'DZ',
        flag: flagDZ,
        dialCode: '213',
        mask: '9999 99 99 99',
    },
    {
        ru: 'американское Самоа',
        lt: 'Amerikos Samoa',
        tr: 'Amerikan Samoası',
        en: 'American Samoa',
        flagIcon: '🇦🇸',
        code: 'AS',
        flag: flagAS,
        dialCode: '1684',
        mask: '(999) 999-9999',
    },
    {
        ru: 'андорра',
        lt: 'Andora',
        tr: 'Andorra',
        en: 'Andorra',
        flagIcon: '🇦🇩',
        code: 'AD',
        flag: flagAD,
        dialCode: '376',
        mask: '999 999',
    },
    {
        ru: 'Ангола',
        lt: 'Angoloje',
        tr: 'Angora',
        en: 'Angola',
        flagIcon: '🇦🇴',
        code: 'AO',
        flag: flagAO,
        dialCode: '244',
        mask: '999 999 999',
    },
    {
        ru: 'Ангилья',
        lt: 'Angilija',
        tr: 'Anguilla',
        en: 'Anguilla',
        flagIcon: '🇦🇮',
        code: 'AI',
        flag: flagAI,
        dialCode: '1264',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Антигуа и Барбуда',
        lt: 'Antigva ir Barbuda',
        tr: 'Antigua ve Barbuda',
        en: 'Antigua and Barbuda',
        flagIcon: '🇦🇬',
        code: 'AG',
        flag: flagAG,
        dialCode: '1268',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Аргентина',
        lt: 'Argentina',
        tr: 'Arjantin',
        en: 'Argentina',
        flagIcon: '🇦🇷',
        code: 'AR',
        flag: flagAR,
        dialCode: '54',
        mask: '99 9999-9999',
    },
    {
        ru: 'Армения',
        lt: 'Armėnija',
        tr: 'Ermenistan',
        en: 'Armenia',
        flagIcon: '🇦🇲',
        code: 'AM',
        flag: flagAM,
        dialCode: '374',
        mask: '999 999999',
    },
    {
        ru: 'Аруба',
        lt: 'Aruba',
        tr: 'Aruba',
        en: 'Aruba',
        flagIcon: '🇦🇼',
        code: 'AW',
        flag: flagAW,
        dialCode: '297',
        mask: '999 9999',
    },
    {
        ru: 'Австралия',
        lt: 'Australija',
        tr: 'Avustralya',
        en: 'Australia',
        flagIcon: '🇦🇺',
        code: 'AU',
        flag: flagAU,
        dialCode: '61',
        mask: '9999 999 999',
    },
    {
        ru: 'Австрия',
        lt: 'Austrijoje',
        tr: 'Avusturya',
        en: 'Austria',
        flagIcon: '🇦🇹',
        code: 'AT',
        flag: flagAT,
        dialCode: '43',
        mask: '9999 999999',
    },
    {
        ru: 'Азербайджан',
        lt: 'Azerbaidžanas',
        tr: 'Azerbeycan',
        en: 'Azerbaijan',
        flagIcon: '🇦🇿',
        code: 'AZ',
        flag: flagAZ,
        dialCode: '994',
        mask: '999 999 99 99',
    },
    {
        ru: 'Багамские о-ва',
        lt: 'Bahamos',
        tr: 'Bahamalar',
        en: 'Bahamas',
        flagIcon: '🇧🇸',
        code: 'BS',
        flag: flagBS,
        dialCode: '1242',
        mask: '(999) 999-999',
    },
    {
        ru: 'Бахрейн',
        lt: 'Bahreinas',
        tr: 'Bahreyn',
        en: 'Bahrain',
        flagIcon: '🇧🇭',
        code: 'BH',
        flag: flagBH,
        dialCode: '973',
        mask: '9999 9999',
    },
    {
        ru: 'Бангладеш',
        lt: 'Bangladešas',
        tr: 'Bangladeş',
        en: 'Bangladesh',
        flagIcon: '🇧🇩',
        code: 'BD',
        flag: flagBD,
        dialCode: '880',
        mask: '99999-999999',
    },
    {
        ru: 'Барбадос',
        lt: 'Barbadosas',
        tr: 'Barbados',
        en: 'Barbados',
        flagIcon: '🇧🇧',
        code: 'BB',
        flag: flagBB,
        dialCode: '1246',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Беларусь',
        lt: 'Baltarusija',
        tr: 'Belarus',
        en: 'Belarus',
        flagIcon: '🇧🇾',
        code: 'BY',
        flag: flagBY,
        dialCode: '375',
        mask: '9 999 999-99-99',
    },
    {
        ru: 'Бельгия',
        lt: 'Belgija',
        tr: 'Belçika',
        en: 'Belgium',
        flagIcon: '🇧🇪',
        code: 'BE',
        flag: flagBE,
        dialCode: '32',
        mask: '9999 99 99 99',
    },
    {
        ru: 'Белиз',
        lt: 'Belizas',
        tr: 'Belize',
        en: 'Belize',
        flagIcon: '🇧🇿',
        code: 'BZ',
        flag: flagBZ,
        dialCode: '501',
        mask: '999-9999',
    },
    {
        ru: 'Бенин',
        lt: 'Beninas',
        tr: 'Benin',
        en: 'Benin',
        flagIcon: '🇧🇯',
        code: 'BJ',
        flag: flagBJ,
        dialCode: '229',
        mask: '99 99 99 99',
    },
    {
        ru: 'Бермудские острова',
        lt: 'Bermudai',
        tr: 'Bermuda',
        en: 'Bermuda',
        flagIcon: '🇧🇲',
        code: 'BM',
        flag: flagBM,
        dialCode: '1441',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Бутан',
        lt: 'Butanas',
        tr: 'Butan',
        en: 'Bhutan',
        flagIcon: '🇧🇹',
        code: 'BT',
        flag: flagBT,
        dialCode: '975',
        mask: '99 99 99 99',
    },
    {
        ru: 'Боливия, Многонациональное Государство Боливия',
        lt: 'Bolivija, Bolivijos daugiakalbė valstybė',
        tr: 'Bolivya, Bolivya Çokuluslu Devleti',
        en: 'Bolivia, Plurinational State of bolivia',
        flagIcon: '🇧🇴',
        code: 'BO',
        flag: flagBO,
        dialCode: '591',
        mask: '99999999',
    },
    {
        ru: 'Босния и Герцеговина',
        lt: 'Bosnija ir Hercegovina',
        tr: 'Bosna Hersek',
        en: 'Bosnia and Herzegovina',
        flagIcon: '🇧🇦',
        code: 'BA',
        flag: flagBA,
        dialCode: '387',
        mask: '999 999 999',
    },
    {
        ru: 'Ботсвана',
        lt: 'Botsvana',
        tr: 'Botsvana',
        en: 'Botswana',
        flagIcon: '🇧🇼',
        code: 'BW',
        flag: flagBW,
        dialCode: '267',
        mask: '99 999 999',
    },
    {
        ru: 'Остров Буве',
        lt: 'Bouvet sala',
        tr: 'Bouvet Adası',
        en: 'Bouvet Island',
        flagIcon: '🇧🇻',
        code: 'BV',
        flag: flagBV,
        dialCode: '47',
        mask: '(99) 99999-9999',
    },
    {
        ru: 'Бразилия',
        lt: 'Brazilija',
        tr: 'Brezilya',
        en: 'Brazil',
        flagIcon: '🇧🇷',
        code: 'BR',
        flag: flagBR,
        dialCode: '55',
        mask: '(99) 99999 9999',
    },
    {
        ru: 'Британская территория Индийского океана',
        lt: 'Britanijos Indijos vandenyno teritorija',
        tr: 'Britanya Hint Okyanusu Toprakları',
        en: 'British Indian Ocean Territory',
        flagIcon: '🇮🇴',
        code: 'IO',
        flag: flagIO,
        dialCode: '246',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Бруней-Даруссалам',
        lt: 'Brunėjaus Darusalamas',
        tr: 'Brunei Sultanlığı',
        en: 'Brunei Darussalam',
        flagIcon: '🇧🇳',
        code: 'BN',
        flag: flagBN,
        dialCode: '673',
        mask: '999 9999',
    },
    {
        ru: 'Болгария',
        lt: 'Bulgarija',
        tr: 'Bulgaristan',
        en: 'Bulgaria',
        flagIcon: '🇧🇬',
        code: 'BG',
        flag: flagBG,
        dialCode: '359',
        mask: '999 999 999',
    },
    {
        ru: 'Буркина-Фасо',
        lt: 'Burkina Fasas',
        tr: 'Burkina Faso',
        en: 'Burkina Faso',
        flagIcon: '🇧🇫',
        code: 'BF',
        flag: flagBF,
        dialCode: '226',
        mask: '99 99 99 99',
    },
    {
        ru: 'Бурунди',
        lt: 'Burundis',
        tr: 'Burundi',
        en: 'Burundi',
        flagIcon: '🇧🇮',
        code: 'BI',
        flag: flagBI,
        dialCode: '257',
        mask: '99 99 99 99',
    },
    {
        ru: 'Камбоджа',
        lt: 'Kambodža',
        tr: 'Kamboçya',
        en: 'Cambodia',
        flagIcon: '🇰🇭',
        code: 'KH',
        flag: flagKH,
        dialCode: '855',
        mask: '999 999 999',
    },
    {
        ru: 'Камерун',
        lt: 'Kamerūnas',
        tr: 'Kamerun',
        en: 'Cameroon',
        flagIcon: '🇨🇲',
        code: 'CM',
        flag: flagCM,
        dialCode: '237',
        mask: '9 99 99 99 99',
    },
    {
        ru: 'Канада',
        lt: 'Kanada',
        tr: 'Kanada',
        en: 'Canada',
        flagIcon: '🇨🇦',
        code: 'CA',
        flag: flagCA,
        dialCode: '1',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Кабо-Верде',
        lt: 'Žaliasis Kyšulys',
        tr: 'Yeşil Burun Adaları',
        en: 'Cape Verde',
        flagIcon: '🇨🇻',
        code: 'CV',
        flag: flagCV,
        dialCode: '238',
        mask: '999 99 99',
    },
    {
        ru: 'Каймановы острова',
        lt: 'Kaimanų salos',
        tr: 'Cayman Adaları',
        en: 'Cayman Islands',
        flagIcon: '🇰🇾',
        code: 'KY',
        flag: flagKY,
        dialCode: '345',
        mask: '999 9999',
    },
    {
        ru: 'Центрально-Африканская Республика',
        lt: 'Centrine Afrikos Respublika',
        tr: 'Orta Afrika Cumhuriyeti',
        en: 'Central African Republic',
        flagIcon: '🇨🇫',
        code: 'CF',
        flag: flagCF,
        dialCode: '236',
        mask: '99 99 99 99',
    },
    {
        ru: 'Чад',
        lt: 'Čadas',
        tr: 'Çad',
        en: 'Chad',
        flagIcon: '🇹🇩',
        code: 'TD',
        flag: flagTD,
        dialCode: '235',
        mask: '99 99 99 99',
    },
    {
        ru: 'Чили',
        lt: 'Čilė',
        tr: 'Şili',
        en: 'Chile',
        flagIcon: '🇨🇱',
        code: 'CL',
        flag: flagCL,
        dialCode: '56',
        mask: '(9) 9999 9999',
    },
    {
        ru: 'Китай',
        lt: 'Kinija',
        tr: 'Çin',
        en: 'China',
        flagIcon: '🇨🇳',
        code: 'CN',
        flag: flagCN,
        dialCode: '86',
        mask: '999 9999 9999',
    },
    {
        ru: 'Остров Рождества',
        lt: 'Kalėdų sala',
        tr: 'Noel Adası',
        en: 'Christmas Island',
        flagIcon: '🇨🇽',
        code: 'CX',
        flag: flagCX,
        dialCode: '61',
        mask: '9999 999 999',
    },
    {
        ru: 'Кокосовые (Килинг) острова',
        lt: 'Kokosų (Kylingo) salos',
        tr: 'Cocos (Keeling) Adaları',
        en: 'Cocos (Keeling) Islands',
        flagIcon: '🇨🇨',
        code: 'CC',
        flag: flagCC,
        dialCode: '61',
        mask: '9999 999 999',
    },
    {
        ru: 'Колумбия',
        lt: 'Kolumbija',
        tr: 'Kolombiya',
        en: 'Colombia',
        flagIcon: '🇨🇴',
        code: 'CO',
        flag: flagCO,
        dialCode: '57',
        mask: '999 9999999',
    },
    {
        ru: 'Коморские острова',
        lt: 'Komorai',
        tr: 'Komorlar',
        en: 'Comoros',
        flagIcon: '🇰🇲',
        code: 'KM',
        flag: flagKM,
        dialCode: '269',
        mask: '999 99 99',
    },
    {
        ru: 'Конго',
        lt: 'Kongas',
        tr: 'Kongo',
        en: 'Congo',
        flagIcon: '🇨🇬',
        code: 'CG',
        flag: flagCG,
        dialCode: '242',
        mask: '9999 999 999',
    },
    {
        ru: 'Конго, Демократическая Республика Конго',
        lt: 'Kongo Demokratinė Kongo Respublika',
        tr: 'Kongo, Demokratik Kongo Cumhuriyeti',
        en: 'Congo, The Democratic Republic of the Congo',
        flagIcon: '🇨🇩',
        code: 'CD',
        flag: flagCD,
        dialCode: '243',
        mask: '99 999 9999',
    },
    {
        ru: 'Острова Кука',
        lt: 'Kuko salos',
        tr: 'Cook Adaları',
        en: 'Cook Islands',
        flagIcon: '🇨🇰',
        code: 'CK',
        flag: flagCK,
        dialCode: '682',
        mask: '99 999',
    },
    {
        ru: 'Коста Рика',
        lt: 'Kosta Rika',
        tr: 'Kosta Rika',
        en: 'Costa Rica',
        flagIcon: '🇨🇷',
        code: 'CR',
        flag: flagCR,
        dialCode: '506',
        mask: '9999 9999',
    },
    {
        ru: 'Берег Слоновой Кости',
        lt: 'Dramblio Kaulo Krantas',
        tr: 'Fildişi Sahili',
        en: "Cote d'Ivoire",
        flagIcon: '🇨🇮',
        code: 'CI',
        flag: flagCI,
        dialCode: '225',
        mask: '99 99 99 99',
    },
    {
        ru: 'Хорватия',
        lt: 'Kroatija',
        tr: 'Hırvatistan',
        en: 'Croatia',
        flagIcon: '🇭🇷',
        code: 'HR',
        flag: flagHR,
        dialCode: '385',
        mask: '999 999 9999',
    },
    {
        ru: 'Куба',
        lt: 'Kuba',
        tr: 'Küba',
        en: 'Cuba',
        flagIcon: '🇨🇺',
        code: 'CU',
        flag: flagCU,
        dialCode: '53',
        mask: '99 9999999',
    },
    {
        ru: 'Кипр',
        lt: 'Kipras',
        tr: 'Kıbrıs',
        en: 'Cyprus',
        flagIcon: '🇨🇾',
        code: 'CY',
        flag: flagCY,
        dialCode: '357',
        mask: '99 999999',
    },
    {
        ru: 'Республика Чехия',
        lt: 'Čekijos Respublika',
        tr: 'Çek Cumhuriyeti',
        en: 'Czech Republic',
        flagIcon: '🇨🇿',
        code: 'CZ',
        flag: flagCZ,
        dialCode: '420',
        mask: '999 999 999',
    },
    {
        ru: 'Дания',
        lt: 'Danija',
        tr: 'Danimarka',
        en: 'Denmark',
        flagIcon: '🇩🇰',
        code: 'DK',
        flag: flagDK,
        dialCode: '45',
        mask: '99 99 99 99',
    },
    {
        ru: 'Джибути',
        lt: 'Džibutis',
        tr: 'Cibuti',
        en: 'Djibouti',
        flagIcon: '🇩🇯',
        code: 'DJ',
        flag: flagDJ,
        dialCode: '253',
        mask: '99 99 99 99',
    },
    {
        ru: 'Доминика',
        lt: 'Dominika',
        tr: 'Dominika',
        en: 'Dominica',
        flagIcon: '🇩🇲',
        code: 'DM',
        flag: flagDM,
        dialCode: '1767',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Эквадор',
        lt: 'Ekvadoras',
        tr: 'Ekvador',
        en: 'Ecuador',
        flagIcon: '🇪🇨',
        code: 'EC',
        flag: flagEC,
        dialCode: '593',
        mask: '999 999 9999',
    },
    {
        ru: 'Египет',
        lt: 'Egiptas',
        tr: 'Mısır',
        en: 'Egypt',
        flagIcon: '🇪🇬',
        code: 'EG',
        flag: flagEG,
        dialCode: '20',
        mask: '9999 999 9999',
    },
];
export default CountriesA;
